import React, { useState } from "react";
import Overview from "./Overview";
import Compare from "./Compare";
import styled from "styled-components";
import Breadcrumbs from "../../components/Breadcrumbs";
import { Tabs } from "antd";
import Detail from "./Detail";
import { useDispatch } from "react-redux";
import { apiRevenueMagicWheel } from "../../../api/ApiMytel";
import { getDataMagicWheel, getDataRevenueMovitel } from "../../../redux/Future/Movitel/action";
import { apiRevenueMovitel } from "../../../api/ApiMovitel";

export default function MovitelMagicWheel() {
  const [tabActive, setTabActive] = useState("1");
  const dispatch = useDispatch();

  const handleGetData = (startDate, endDate) => {
    dispatch(getDataRevenueMovitel(apiRevenueMovitel(startDate, endDate)));
  };

  const items = [
    {
      key: "1",
      label: "Overview",
      children: <Overview tabActive={tabActive} handleGetData={handleGetData}/>,
    },
    {
      key: "2",
      label: "Details",
      children: <Detail tabActive={tabActive} handleGetData={handleGetData}/>,
    },
    {
      key: "3",
      label: "Compare",
      children: <Compare tabActive={tabActive} handleGetData={handleGetData}/>,
    },
  ];

  const onChangeTabs = (key) => {
    setTabActive(key);
  };
  return (
    <Container>
      <Breadcrumbs data={["Movitel", "Letra Magica"]} />
      <div className="container-dashboard">
        <Tabs defaultActiveKey="1" items={items} onChange={onChangeTabs} />
      </div>
    </Container>
  );
}

const Container = styled.div`
  .ant-tabs-tab {
    font-size: 15px;
    padding: 5px 20px;
  }
`;
